module.exports = [
  {
    id: 2,
    name: 'Администраторы'
  },
  {
    id: 3,
    name: 'Информационная система'
  },
  {
    id: 4,
    name: 'Тестирование системы'
  },
  {
    id: 5,
    name: 'Эксперты'
  }
]
